<template>
  <div class="footer">
    <div class="container">
      <router-link to="/" class="logo">
        <img src="@/assets/img/Logo_wh.svg" />
      </router-link>

      <div class="footer-body">
        <div class="footer-left">
          <ul class="footer-list footer-list--1">
            <li class="footer-list__item footer-list__item--header">О компании</li>
            <li class="footer-list__item">
              <router-link to="/achievements">Награды</router-link>
            </li>
            <li class="footer-list__item">
              <router-link to="/directorship">Руководство</router-link>
            </li>
            <li class="footer-list__item">
              <router-link to="/documents">Документы</router-link>
            </li>
            <li class="footer-list__item">
              <router-link to="/sout">Результаты СОУТ</router-link>
            </li>
            <li class="footer-list__item">
              <router-link to="/contacts">Контакты</router-link>
            </li>
          </ul>

          <ul class="footer-list footer-list--2">
            <li class="footer-list__item footer-list__item--header">Проекты</li>
            <li class="footer-list__item">
              <router-link to="/projects">Портфель проектов</router-link>
            </li>
            <li class="footer-list__item">
              <router-link to="/estate">Продажа недвижимости</router-link>
            </li>
          </ul>
        </div>

        <div class="footer-center">
          <p class="text">Отдел продаж</p>
          <a :href="`tel: ${contacts.salesNumber}`">{{ contacts.salesNumber }}</a>
          <p class="text">Приемная</p>
          <a :href="`tel: ${contacts.receptionNumber}`">{{ contacts.receptionNumber }}</a>
          <p class="text">Почта</p>
          <a :href="`mailto: ${contacts.email}`" class="mail">{{ contacts.email }}</a>
          <p class="text">Мы в социальных сетях</p>
          <div class="social">
            <!-- <a :href="contacts.instagram" target="_blank" v-if="contacts.instagram">
              <img src="@/assets/img/instagram_wh.svg" />
            </a> -->
            <a :href="contacts.vk" target="_blank" v-if="contacts.vk">
              <img src="@/assets/img/vk_wh.svg" />
            </a>
            <a :href="contacts.facebook" target="_blank" v-if="contacts.facebook">
              <img src="@/assets/img/facebook_wh.svg" />
            </a>
          </div>
        </div>

        <div class="footer-right">
          <ul class="footer-list footer-list--3">
            <li class="footer-list__item footer-list__item--header">Сотрудничество</li>
            <li class="footer-list__item">
              <router-link to="/customer">Заказчикам</router-link>
            </li>
            <li class="footer-list__item">
              <router-link to="/contractor">Подрядчикам</router-link>
            </li>
            <li class="footer-list__item">
              <router-link to="/investor">Инвесторам</router-link>
            </li>
            <!-- <li class="footer-list__item">
              <router-link to="/tenders">Тендеры</router-link>
            </li> -->
            <li class="footer-list__item">
              <router-link to="/career">Вакансии</router-link>
            </li>
          </ul>

          <ul class="footer-list footer-list--4">
            <li class="footer-list__item footer-list__item--header">Пресс-центр</li>
            <li class="footer-list__item">
              <router-link to="/news">Новости</router-link>
            </li>
            <li class="footer-list__item">
              <router-link to="/photos">Фотоархив</router-link>
            </li>
            <li class="footer-list__item">
              <router-link to="/videos">Видеоархив</router-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-bottom__left">
          <div class="footer-bottom__copyright">© {{ new Date().getFullYear() }}</div>
          <div class="footer-bottom__polytics" v-if="contacts.politics">
            <a :href="`${API_URL}${contacts.politics.url}`" download>
              Политика конфиденциальности и защиты информации
            </a>
          </div>
        </div>
        <div class="footer-bottom__right">
          Дизайн и создание сайта
          <a href="https://myhart.ru/" target="_blank">
            <img src="@/assets/img/hart_logo.svg" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/sass/footer.sass';
import { mapState } from 'vuex';
import config from '@/config';

export default {
  name: 'FooterBlock',
  computed: {
    ...mapState({
      contacts: (state) => state.contacts.contacts,
    }),
    API_URL() {
      return config.API_URL;
    },
  },
};
</script>
